import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormControl,
} from '@angular/forms';
import { Router } from '@angular/router';
import { AppService } from 'src/app/app.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { CookieService } from 'ngx-cookie-service';
import { LocalStorageService } from '../landingpage/product-list/localStorageService';
declare const grecaptcha: any;
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss', './login.component.css'],
})
export class LoginComponent implements OnInit {
  showPage = 1;
  GenerateUserOTPForm: any;
  ProfileForm: FormGroup;
  // userData: any;
  OTPForm: any;

  @ViewChild('otp1') otp1!: ElementRef;

  @ViewChild('otp2') otp2!: ElementRef;

  @ViewChild('otp3') otp3!: ElementRef;

  @ViewChild('otp4') otp4!: ElementRef;
  genderType: any;
  CartListData: any;

  validationState: string;
  ref_ErrorMsg: any;
  ref_SuccessTip: string;
  constructor(
    private router: Router,
    private fb: FormBuilder,
    public _appService: AppService,
    private nzMessageService: NzMessageService,
    private CookieService: CookieService,
    private localStorageService: LocalStorageService
  ) {
    this._appService.showPage.subscribe((data: any) => {
      console.log(data);
      this.showPage = data;
    });
  }

  ngOnInit() {
    const script = document.createElement('script');
    script.src = 'https://www.google.com/recaptcha/api.js';
    document.head.appendChild(script);
    this.GenerateUserOTPForm = new FormGroup({
      PhoneNumber: new FormControl(null, [Validators.required]),
    });
    this.GenerateUserOTPForm = new FormGroup({
      PhoneNumber: new FormControl(null, [Validators.required]),
    });
    this.OTPForm = new FormGroup({
      Otp1: new FormControl(null, [Validators.required]),
      Otp2: new FormControl(null, [Validators.required]),
      Otp3: new FormControl(null, [Validators.required]),
      Otp4: new FormControl(null, [Validators.required]),
    });
    this.OTPForm.get('Otp1').valueChanges.subscribe((data: string) => {
      if (data.length == 1) {
        this.otp2.nativeElement.focus();
      }
    });
    this.OTPForm.get('Otp2').valueChanges.subscribe((data: string) => {
      if (data.length == 1) {
        this.otp3.nativeElement.focus();
      } else if (data.length == 0) {
        this.otp1.nativeElement.focus();
      }
    });
    this.OTPForm.get('Otp3').valueChanges.subscribe((data: string) => {
      console.log(typeof data);
      if (data.length == 1) {
        this.otp4.nativeElement.focus();
      } else if (data.length == 0) {
        this.otp2.nativeElement.focus();
      }
    });

    this.OTPForm.get('Otp4').valueChanges.subscribe((data: string) => {
      console.log(typeof data);
      if (data.length == 1) {
        setTimeout(() => {
          this.onVerifyOtp();
        }, 200);
      }
      if (data.length == 0) {
        this.otp3.nativeElement.focus();
      }

      //this.GenerateUserOTPForm.reset()
    });
    this.ProfileForm = this.fb.group({
      name: [null, [Validators.required]],
      Mail: [null, [Validators.required]],
      Whether_TC_Accepted: [false, [Validators.required]],
      date: [null, [Validators.required]],
      Ref_PhoneNumber: [''],
    });
    this.ProfileForm.controls.Ref_PhoneNumber.valueChanges.subscribe(
      (data: any) => {
        if (data.length > 0) {
          this.validationState = 'validating';
          this.onCheckRefNumber();
        } else {
          this.validationState = '';
          this.ref_ErrorMsg = '';
        }
      }
    );
  }
  onNavigateHome() {
    this.showPage = 1;
    this.router.navigate(['/']);
  }
  onClickLogin(type: number) {
    if (type == 1) {
      this.showPage = type;
    } else if (type == 2) {
      const reCaptchaResponse = grecaptcha.getResponse();
      console.log(reCaptchaResponse);
      if (reCaptchaResponse) {
        if (this.GenerateUserOTPForm.get('PhoneNumber').value.length == 10) {
          this.onVerify();
        }
      } else {
        alert('verify captcha');
      }
    } else if (type == 3) {
      // this.onVerifyOtp()
      //this.GenerateUserOTPForm.reset()
      this.showPage = 1;
    } else if (type == 4) {
      if (this.ProfileForm.get('Ref_PhoneNumber')?.value.length > 0) {
        this.updateReferralForm();
      } else {
        this.updateProfile();
      }
      // this.showPage = type
    } else if (type == 5) {
      // this.showPage = type
    }
  }
  onVerify() {
    const reCaptchaResponse = grecaptcha.getResponse();
    console.log(reCaptchaResponse);
    if (this.GenerateUserOTPForm.get('PhoneNumber').value.length == 10) {
      const body = {
        CountryCode: '+91',
        PhoneNumber: this.GenerateUserOTPForm.value.PhoneNumber,
        captchaResponse: reCaptchaResponse,
      };

      try {
        this._appService.postMethod('Generate_User_OTP', body).subscribe(
          (resp) => {
            if (resp.success) {
              this.showPage = 2;
              this.nzMessageService.success(resp.extras.Status);
            } else {
              this.nzMessageService.error(resp.extras.msg);
            }
          },
          (error) => {}
        );
      } catch (e) {}
    }
  }

  onVerifyOtp() {
    const body = {
      CountryCode: '91',
      PhoneNumber: this.GenerateUserOTPForm.value.PhoneNumber,
      OTP: `${this.OTPForm.value.Otp1}${this.OTPForm.value.Otp2}${this.OTPForm.value.Otp3}${this.OTPForm.value.Otp4}`,
    };

    try {
      this._appService.postMethod('Validate_User_OTP', body).subscribe(
        (resp) => {
          if (resp.success) {
            let userData = resp.extras.Data;
            this.nzMessageService.success(resp.extras.Status);
            this.GenerateUserOTPForm.reset();
            this.OTPForm.patchValue({
              Otp1: '',
              Otp2: '',
              Otp3: '',
              Otp4: '',
            });

            this.CookieService.set('userData', JSON.stringify(userData));
            console.log(this.CookieService.get('userData'));
            if (!userData.Whether_Basic_Information_Available) {
              this.showPage = 3;
            } else {
              let data = {
                userData: userData,
                emittingType: 1,
              };
              this._appService.logOutEventEmitter.emit(data);
              this._appService.isWebLoginVisible.emit(false);
              this._appService.LoginVisible.emit(false);
              this.onNavigateHome();
              this.getCartItemsList();
            }
          } else {
            this.nzMessageService.error(resp.extras.msg);
          }
        },
        (resp) => {
          this.nzMessageService.error(resp.error.extras.msg);
        }
      );
    } catch (e) {}
  }
  selecteGender(type: number) {
    this.genderType = type;
    console.log(this.genderType);
  }
  updateProfile() {
    const body = {
      Name: this.ProfileForm.value.name,
      Gender: this.genderType,
      DOB: this.ProfileForm.value.date,
      EmailID: this.ProfileForm.value.Mail,
      Whether_TC_Accepted: this.ProfileForm.value.Whether_TC_Accepted,
      Whether_18_Years_Above: this.ProfileForm.value.Whether_18_Years_Above,
      Whether_Image_Available: false,
      ImageID: '',
    };

    try {
      this._appService.postMethod('User_Profile_Update', body).subscribe(
        (resp) => {
          if (resp.success) {
            let userData = resp.extras.Data;
            // this.nzMessageService.success(resp.extras.Status)

            this.CookieService.set('userData', JSON.stringify(userData));
            let data = {
              userData: userData,
              emittingType: 1,
            };
            this._appService.logOutEventEmitter.emit(data);
            this.getCartItemsList();

            // if (this.ProfileForm.get('Ref_PhoneNumber')?.value.length > 0) {
            //   this.updateReferralForm()
            // } else {
            this.nzMessageService.success('Updated Successfully');
            this.ProfileForm.reset({
              Ref_PhoneNumber: '',
            });
            this.validationState = '';
            this.showPage = 4;
            setTimeout(() => {
              this.router.navigate(['/']);
            }, 1000);
            this._appService.isWebLoginVisible.emit(false);
            // }
          } else {
            this.nzMessageService.error(resp.extras.msg);
          }
        },
        (resp) => {
          this.nzMessageService.error(resp.error.extras.msg);
        }
      );
    } catch (e) {}
  }
  updateReferralForm() {
    let body = {
      Ref_PhoneNumber: this.ProfileForm.value.Ref_PhoneNumber,
    };
    try {
      this._appService.postMethod('Submit_User_Referral', body).subscribe(
        (resp) => {
          if (resp.success) {
            this.updateProfile();
            // this.nzMessageService.success("Updated Successfully")
            // this.ProfileForm.reset({
            //   Ref_PhoneNumber:''
            // })
            // this.validationState =''
            // this.showPage = 5
            // this._appService.isWebLoginVisible.emit(false)
          } else {
            // this.nzMessageService.create('error', this._appService.apiMessages[resp.extras.msg]);
          }
        },
        (resp) => {
          // this.nzMessageService.create('error', resp.error.extras.msg);
        }
      );
    } catch (e) {}
  }
  getCartItemsList() {
    console.log('23423');
    let body = { warehouseId: localStorage.getItem('warehouseId') };
    try {
      this._appService.postMethod('List_All_Cart_Items', body).subscribe(
        (resp) => {
          if (resp.success) {
            this.CartListData = resp.extras.Data;
            this._appService.cartInfoEventEmitter.emit(
              this.CartListData.Products_Data
            );
            console.log('login');
            this.localStorageService.setItem(
              'warehouseId',
              resp.extras.Data.warehouseId
            );
          } else {
            // this.nzMessageService.create('error', this._appService.apiMessages[resp.extras.msg]);
          }
        },
        (resp) => {
          // this.nzMessageService.create('error', resp.error.extras.msg);
        }
      );
    } catch (e) {}
  }

  onCheckRefNumber() {
    try {
      this._appService
        .postMethod('Check_referal_PhoneNumber', {
          Ref_PhoneNumber: +this.ProfileForm.get('Ref_PhoneNumber')?.value,
        })
        .subscribe(
          (resp) => {
            if (resp.success) {
              this.validationState = 'success';
              this.ref_SuccessTip = `Validated Successfully ${resp.extras.Status.Name}`;
            } else {
              this.ref_ErrorMsg = resp.error.extras.msg;
              this.validationState = 'error';
              // this.nzMessageService.error(this._appService.apiMessages[resp.extras.msg]);
            }
          },
          (resp) => {
            this.ref_ErrorMsg = resp.error.extras.msg;
            this.validationState = 'error';
          }
        );
    } catch (e) {}
  }
}
